define([
	"csi/def/ActionFactory",
	"csi/widget/MessageDialog",
	"./Purge"
], function(ActionFactory,MessageDialog,Purge) {

	return ActionFactory.declare("PurgeResetRevisions", Purge, {
		m_tag: "PurgeResetRevisions",

		confirmAction: MessageDialog.BUTTON_PURGE_RESET,

		_getStateRoles: function(/*Context*/ctx) {
			// summary: return roles necessary to perform action (if any)
			return ["Revision Approver"];
		}
	});
});